import { render, staticRenderFns } from "./IndexMatch.vue?vue&type=template&id=5a6410d2&scoped=true"
import script from "./IndexMatch.vue?vue&type=script&lang=js"
export * from "./IndexMatch.vue?vue&type=script&lang=js"
import style0 from "./IndexMatch.vue?vue&type=style&index=0&id=5a6410d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6410d2",
  null
  
)

export default component.exports